<template>
  <div class="share">
    <v-dialog
      v-model="dialog"
      max-width="300"
    >
      <v-card flat>
        <v-card-title>
          <span>共有</span>
          <v-spacer />
          <v-btn
            fab
            text
            x-small
            @click="dialog = false"
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col class="col-12 col-sm-6 pr-md-2 mb-3 mb-md-0">
              <v-btn
                block
                depressed
                color="secondary"
                @click="copyLink"
              >
                <v-icon>fa-link</v-icon>
              </v-btn>
            </v-col>
            <v-col class="col-12 col-sm-6 pl-md-2">
              <v-btn
                block
                depressed
                color="#1da1f2"
                dark
                @click="shareTwitter"
              >
                <v-icon>fab fa-twitter</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard';

export default {
  name: 'Share',
  data: () => ({
    dialog: false,
    resolve: null,
    title: null,
    url: null
  }),
  watch: {
    dialog(val) {
      if (!val) {
        this.resolve();
      }
    }
  },
  methods: {
    open(title, url) {
      if (this.$_isMobile && navigator.share) {
        return navigator.share({
          title,
          url
        })
          .catch(() => {
            console.log('share cancel');
          });
      }
      return new Promise(resolve => {
        this.title = title;
        this.url = url;
        this.dialog = true;
        this.resolve = resolve;
      });
    },
    copyLink(url) {
      copy(this.url || url);
      this.$_pushNotice('リンクをコピーしました。', 'success');
    },
    shareTwitter(title, url) {
      const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.title || title)}&url=${this.url || url}`;
      window.open(shareUrl, '_blank');
    }
  }
};
</script>
